import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-139">
      {/* Dark textured background simulation */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gray-700 via-gray-900 to-black" data-id="element-140"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-142">
          <h2 className="font-sans text-3xl md:text-5xl font-black uppercase tracking-wide mb-4 leading-tight" data-id="element-143">
            ¡No solo recibes el curso de Velas y Jabones Artesanales para
            emprender premium,{' '}
            <span className="text-artisanal-terracotta" data-id="element-144">
              sino que te llevas todo esto!
            </span>
          </h2>
        </motion.div>

        {/* Bonuses Image — exact reference layout */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mb-12" data-id="element-145">
          <img src="https://cdn.magicpatterns.com/uploads/tkgeibufTn98tXGVt6cV2J/Captura_de_pantalla_2026-04-25_a_la(s)_3.04.26_p.m..jpg" alt="18 bonuses incluidos: Desmaquillante Natural, Velas De Fechas Especiales, Decoración de envases, Certificado, Mantequilla Corporal, Shampoo en Barra, Bombas de Baño, +100 Recetas de Jabones, Comunidad VIP, Módulo de emprendimiento, Cajas sorpresa, Manifiesta con las velas, Actualizaciones, Lista de proveedores, Varita Difusora, Bálsamo Labial, Técnica Saponificación en frío y más" className="w-full rounded-2xl shadow-2xl" data-id="element-146" />
        </motion.div>

        {/* Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-artisanal-terracotta text-white text-center py-5 px-6 rounded-xl mb-12 shadow-lg" data-id="element-147">
          <h3 className="font-sans text-2xl md:text-4xl font-bold" data-id="element-148">
            ¡Accede hoy mismo y obtén 18 bonus de regalo!
          </h3>
          <p className="font-sans text-lg md:text-xl mt-2 opacity-90" data-id="element-149">
            ¿Cuánto invertirías por todo este conocimiento para lanzar y hacer
            crecer tu propio negocio?
          </p>
        </motion.div>

        {/* Pricing & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} id="pricing" className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 max-w-3xl mx-auto text-center shadow-2xl" data-id="element-150">
          <h4 className="font-serif text-2xl mb-2 text-artisanal-brown" data-id="element-151">
            Tu inversión hoy:
          </h4>
          <div className="inline-block bg-artisanal-terracotta/10 text-artisanal-terracotta font-bold text-sm px-4 py-1 rounded-full mb-4 font-sans" data-id="element-152">
            🔥 50% DE DESCUENTO — Oferta por tiempo limitado
          </div>
          <div className="flex items-center justify-center space-x-4 mb-8" data-id="element-153">
            <span className="text-3xl text-gray-400 line-through font-sans" data-id="element-154">
              $90
            </span>
            <span className="text-6xl font-black text-artisanal-terracotta font-sans" data-id="element-155">
              $45
            </span>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full md:w-auto bg-artisanal-terracotta text-white font-sans font-bold text-xl px-12 py-5 rounded-full shadow-[0_10px_20px_rgba(196,112,75,0.3)] hover:bg-artisanal-terracotta/90 transition-all" onClick={() => window.open('https://go.hotmart.com/M105552905G?ap=67a0', '_blank')} data-id="element-156">
            Quiero empezar ahora
          </motion.button>

          <p className="mt-6 text-sm text-gray-500 flex items-center justify-center" data-id="element-157">
            <ShieldCheck className="w-4 h-4 mr-2 text-green-500" data-id="element-158" />
            Pago 100% seguro. Acceso inmediato.
          </p>
        </motion.div>
      </div>
    </section>;
}